import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String,
    enabled: Boolean,
    nonce: String,
  };

  connect() {
    if (!this.enabledValue) return;

    const scriptTag = this.createScriptTag();
    document.head.appendChild(scriptTag);

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", this.idValue, { send_page_view: false });

    document.addEventListener("turbo:load", function () {
      window.gtag("event", "page_view", {
        send_to: this.idValue,
      });
    });
  }

  createScriptTag() {
    const scriptTag = document.createElement("script");
    scriptTag.setAttribute("async", true);
    scriptTag.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${this.idValue}`);
    scriptTag.setAttribute("nonce", this.nonceValue);
    return scriptTag;
  }
}
